module.exports = __webpack_public_path__ + "fonts/LatoLatin-Heavy.9133053.woff2";